
import Vue from 'vue';
import { AppointmentModel } from '@descomplica/dex-models';
import { Avatar } from '@descomplica/vue-components';
import { getPaddedDisplayNumber } from '@/helpers/string';
import { getCountdownTime, isToday, SHORT_MONTHS } from '@/helpers/date';
import i18n from '../../i18n';
import { TranslateResult } from 'vue-i18n';
import moment from 'moment';

interface Data {
  time: number;
  isToday: boolean;
  isNow: boolean;
  counter: any;
}

export default Vue.extend({
  components: {
    Avatar,
  },
  props: {
    appointment: {
      required: true,
      type: Object as Vue.PropType<AppointmentModel>,
    },
  },
  data(): Data {
    return {
      time: 0,
      isToday: false,
      isNow: false,
      counter: null,
    };
  },
  computed: {
    teacherPhoto(): string {
      return (
        this.appointment.event?.avatarUrl || `${process.env.BASE_URL || ''}img/CollegeLogo.svg`
      );
    },
    name(): TranslateResult {
      return this.appointment.event ? this.appointment.event.name : i18n.t('exam');
    },
    date(): string {
      if (this.isNow) {
        return `${i18n.t('now')}`;
      }

      if (this.isToday) {
        return `${i18n.t('today')}`;
      }

      return `${getPaddedDisplayNumber(this.appointment.start.getDate())} ${
        SHORT_MONTHS[this.appointment.start.getMonth()]
      }.`;
    },
    hour(): string {
      if (this.isNow) {
        if (this.time <= 0) {
          return `${i18n.t('happening')}`;
        }

        const seconds = this.time % 60;
        const minutes = (this.time - seconds) / 60;

        return `${i18n.t('startIn')} ${getPaddedDisplayNumber(minutes)}:${getPaddedDisplayNumber(
          seconds,
        )}`;
      }

      const { start, end } = this.appointment;

      const startMoment = moment(start).format('HH:mm');
      let endMoment: string;

      if (!end) {
        start.setHours(start.getHours() + 1);
        endMoment = moment(start).format('HH:mm');
      } else {
        endMoment = moment(end).format('HH:mm');
      }

      return `${startMoment} - ${endMoment}`;
    },
    modeLabel(): TranslateResult {
      if (this.appointment.isLive()) {
        return i18n.t('tutoring');
      }

      if (this.appointment.isExam()) {
        return i18n.t('onSiteExam');
      }

      return '';
    },
  },
  created() {
    const { seconds, hours } = getCountdownTime(this.appointment.start.toISOString());

    if (!isToday(this.appointment.start.toISOString())) {
      this.isToday = false;
      this.isNow = false;
      return;
    }

    this.isToday = true;
    if (hours > 0) {
      return;
    }

    this.isNow = true;
    this.time = seconds;

    this.counter = setInterval(() => {
      this.time -= 1;
      if (this.time < 0) {
        clearInterval(this.counter);
      }
    }, 1000);
  },
});
